import defaultConfig, { LEFT, RIGHT } from '../default/config_default';
import { cloneDeep } from 'lodash';

let page = cloneDeep(defaultConfig);

page.imageSrc = 'background/strona_007.jpg';
page.games = [
  {
    id: 'page006_game11',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 1280,
    },
    item: {
      id: 'page006_game11',
    },
    rectangle: {
      id: 'page007_rect1',
    },
  },
  {
    id: 'page007_game2',
    icon: 'ikonaStepbystep',

    pos: {
      x: RIGHT,
      y: 223,
    },
    item: {
      id: 'page007_game2',
    },
    rectangle: {
      id: 'page007_rect0',
    },
  },
];
page.rectangle = [
  {
    id: 'page007_rect0',

    tooltip: '',

    linked: ['page007_game2'],
    x: 1421,
    y: 223,
    width: 387,
    height: 770,
  },
  {
    id: 'page007_rect1',

    tooltip: '',

    linked: ['page006_game11'],
    x: 1410,
    y: 1308,
    width: 327,
    height: 880,
  },
];
page.images = [
  {
    imageId: 'page007_zoom0',
    rectangle: {
      x: 136,
      y: 1308,
      width: 1253,
      height: 1153,
    },
    imageSrc: 'images/page007/007_5_razem.jpg',
  },
  {
    imageId: 'page007_zoom1',
    rectangle: {
      x: 148,
      y: 256,
      width: 1206,
      height: 708,
    },
    imageSrc: 'images/page007/007 1.jpg',
  },
];
export default page;
